import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.PARCEL_SUPABASE_URL;
const supabaseKey = process.env.PARCEL_SUPABASE_ANON_KEY;

// Generate or retrieve a unique session ID for this user
let sessionId = localStorage.getItem('candle_session_id');
if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem('candle_session_id', sessionId);
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
    global: {
        headers: {
            'x-session-id': sessionId
        }
    }
});

export const getSessionId = () => sessionId;